module.exports = __webpack_public_path__ + "static/media/success_icon.ac4a199d.svg";